import { render } from "./ProductStatistics.vue?vue&type=template&id=664a2f54&scoped=true"
import script from "./ProductStatistics.vue?vue&type=script&lang=js"
export * from "./ProductStatistics.vue?vue&type=script&lang=js"

import "./ProductStatistics.vue?vue&type=style&index=0&id=664a2f54&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664a2f54"]])

export default __exports__